export class ReportArea {
  code: string;
  name: string;
  icon?: string;
  permissions?: string[];
}
